import { render, staticRenderFns } from "./MemberPriceRow.vue?vue&type=template&id=472cca20&scoped=true&"
import script from "./MemberPriceRow.vue?vue&type=script&lang=ts&"
export * from "./MemberPriceRow.vue?vue&type=script&lang=ts&"
import style0 from "./MemberPriceRow.vue?vue&type=style&index=0&id=472cca20&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472cca20",
  null
  
)

export default component.exports